export const heart = () => (
  <path
    d="M13.61 4.674A5.83 5.83 0 0012 8.714a5.83 5.83 0 00-1.61-4.04A5.398 5.398 0 006.5 3a5.397 5.397 0 00-3.89 1.674A5.83 5.83 0 001 8.714C1 16.714 12 21 12 21s11-4.286 11-12.286a5.83 5.83 0 00-1.61-4.04A5.398 5.398 0 0017.5 3a5.398 5.398 0 00-3.89 1.674z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
